import { combineReducers } from 'redux';
import { persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/es/storage'; // default: localStorage
import { routerReducer } from 'react-router-redux';
import { reducer as costEstimate } from '../modules/costEstimate';
import { reducer as inspection } from '../modules/inspection';
import { reducer as inspectionType } from '../modules/inspectionType';
import { reducer as formSchema } from '../modules/formSchema';
import { reducer as uiSchema } from '../modules/uiSchema';
import { reducer as validatorSchema } from '../modules/validatorSchema';
import { reducer as formData } from '../modules/formData';
import { reducer as auth } from '../modules/auth';
import { reducer as user } from '../modules/user';
import { reducer as reports } from '../modules/reports';
import { LOGOUT_SUCCESS } from '../modules/auth/auth.actionTypes';
const config = {
  key: 'wihuri-mia',
  storage,
};
const initialState = {
  timer: 0,
};
const tickReducer = (state = initialState, action) => {
  if (action.type === 'Offline/SCHEDULE_RETRY') {
    return {
      ...state,
      timer: action.payload.delay / 1000,
    };
  }
  if (action.type === 'TICK') {
    return {
      ...state,
      timer: state.timer === 0 ? 0 : state.timer - 1,
    };
  }
  return state;
};

const entities = combineReducers({
  formSchema,
  uiSchema,
  validatorSchema,
  formData,
  costEstimate,
  inspection,
  inspectionType,
  user,
  reports,
});

const appReducer = persistCombineReducers(config, {
  entities,
  router: routerReducer,
  auth: auth,
  timer: tickReducer,
});

const rootReducer = (state = initialState, action) => {
  if (action.type === LOGOUT_SUCCESS) {
    state = { ...initialState, router: state.router };
  }
  return appReducer(state, action);
};
export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js